import type { User } from '@/types/user'
import { type StateCreator } from 'zustand'

export interface UserState {
  user: User | null
  isLoggedIn: boolean
  _hasHydrated: boolean
  warehouseId: string | null
}

export interface UserActions {
  login: (user: User) => void
  logout: () => void
  setHasHydrated: (state: boolean) => void
  setWarehouseId: (id: string | null) => void
}

export type UserSlice = UserState & UserActions

export const createUserSlice: StateCreator<
  UserSlice,
  [],
  [['zustand/persist', unknown]],
  UserSlice
> = (set) => ({
  user: null,
  isLoggedIn: false,
  _hasHydrated: false,
  warehouseId: null,

  login: (userData) =>
    set({
      user: userData,
      isLoggedIn: true
    }),
  logout: () =>
    set({
      user: null,
      isLoggedIn: false,
      warehouseId: null
    }),
  setWarehouseId: (id) =>
    set({
      warehouseId: id
    }),
  setHasHydrated: (state) => {
    set({
      _hasHydrated: state
    })
  }
})
